export default class ForecastRuleFetch {
  function: string;
  params: object | undefined;

  constructor(functionValue: string, params: object | undefined) {
    this.function = functionValue;
    this.params = params;
  }
}
